import { Box, Stack, useTheme } from "@mui/material";
import { Outlet } from "react-router";
import { useResponsiveBreakpoints } from "src/utils/useResponsiveBreakpoints";

type MainContentLayoutProps = {
    children?: ReactNode;
};
export const MainContentLayout = (props: MainContentLayoutProps) => {
    const theme = useTheme();
    const { isMobile } = useResponsiveBreakpoints();
    return (
        <Stack
            sx={{
                display: "flex",
                padding: isMobile ? theme.spacing(6, 2, 2) : theme.spacing(3, 6.5),
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    maxWidth: theme.breakpoints.values.xl,
                }}
            >
                {props.children ? props.children : <Outlet />}
            </Box>
        </Stack>
    );
};
